import { SocialPreviewProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: SocialPreviewProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SocialPreviewProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      title: 'Click me!'.repeat(27),
      description: 'a short description for a site'.repeat(8),
      previewUrl: 'www.site-name.com'.repeat(28),
    } as SocialPreviewProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
